// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"636":"landing","742":"public-document","933":"auth","945":"dashboard"}[chunkId] || chunkId) + "." + {"100":"f756c358","245":"fc6170f6","255":"cb5e9d3d","274":"3ecbade4","277":"50c061b5","636":"286cfc18","742":"e7f777f8","933":"a2a09415","945":"9cc6d1c6"}[chunkId] + ".chunk.js";
};